// KeyboardEvent types `key` as string, but autofill and password managers
// dispatch synthetic keydown events where it is undefined at runtime, so the
// type widens it to force call sites to handle that.
export type SidebarToggleShortcutEvent = Pick<
  KeyboardEvent,
  "altKey" | "ctrlKey" | "metaKey" | "shiftKey"
> & { key: string | undefined };

export const isSidebarToggleShortcut = (event: SidebarToggleShortcutEvent) => {
  if (event.altKey || event.shiftKey) {
    return false;
  }

  const key = event.key?.toLowerCase();
  if (key === "b") {
    return event.metaKey || event.ctrlKey;
  }

  return event.key === "[" && !event.metaKey && !event.ctrlKey;
};
